import React, { useEffect, useState } from "react";
import { BiColor } from "react-icons/bi";
import { GetBookingHistory } from "../Service/API/Get";
import RewardsIcon from "../assets/rewards-icon.png"
import ArrowLeft from "../assets/left-icon.png"
import { Link } from 'react-router-dom'

export default function BookingHistory() {
    const [bookingHistoryDetail, setBookingHistoryDetail] = useState([]);

    useEffect(() => {
        const fetchBookingHistory = async () => {
            const response = await GetBookingHistory();
            setBookingHistoryDetail(response?.data?.result?.data)
        };
        fetchBookingHistory();
    }, []);

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear().toString().slice(0, 4);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    };

    const formatBalance = (balance) => {
        return `₹${Math.round(balance)}`;
    };

    return (
        <>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>

            <div className="container">

                <div className='inner_title_section'>
                    <div className='container'>
                        <div className='inner_title_flex'>
                            <Link to='/booking'> <img src={ArrowLeft} /></Link>
                            <h3>Booking History</h3>
                        </div>
                    </div>
                </div>
                <div className="wallet_box booking_history">
                    <div className="wallet_box_top">
                        <h4>Booking History</h4>
                    </div>
                    <div className="table-responsive">
                        <table className="table history_table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Balance Before Change</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookingHistoryDetail?.map((detail, index) => (
                                    <tr key={index}>
                                        <td>{formatDate(detail?.createdAt)}</td>
                                        <td>{detail?.type}</td>
                                        <td>{formatBalance(detail?.balBefore)}</td>
                                        <td>
                                            {detail?.balBefore > 10000 ? (
                                                <span className="type_credit_red">- ₹{detail?.amount}</span>
                                            ) : (
                                                <>
                                                    <span className="type_credit">+ ₹{detail?.amount}</span>
                                                </>
                                            )}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}